<template>
  <form id="form-home" @submit.prevent="addOrder" class="form formblock__form">
    <h3 class="form__title">
      Начните с простого шага — <br /><b>запишитесь на консультацию</b>
    </h3>
    <div class="form-block__input-group">
      <input
        v-model="name"
        :class="{
          'is-invalid':
            ($v.name.$dirty && !$v.name.required) ||
            ($v.name.$dirty && !$v.name.minLength),
        }"
        class="input"
        name="formblockName"
        type="text"
        placeholder="Как вас зовут?"
        id="form-home-name"
      />
      <label class="invalid" v-if="$v.name.$dirty && !$v.name.required"
        >Обязательное поле.</label
      >
      <label class="invalid" v-else-if="$v.name.$dirty && !$v.name.minLength"
        >Имя должно быть больше 3 букв</label
      >
    </div>
    <div class="form-block__input-group">
      <input
        v-model="phone"
        :class="{
          'is-invalid':
            ($v.phone.$dirty && !$v.phone.required) ||
            ($v.phone.$dirty && !$v.phone.isPhone),
        }"
        class="input"
        name="formblockTel"
        type="tel"
        placeholder="Введите номер телефона"
        id="form-home-phone"
      />
      <label class="invalid" v-if="$v.phone.$dirty && !$v.phone.required"
        >Обязательное поле.</label
      >
      <label class="invalid" v-else-if="$v.phone.$dirty && !$v.phone.isPhone"
        >Неверный формат номера</label
      >
    </div>
    <h5 class="form__radio-container__title">Выберите удобный способ связи</h5>
    <div class="form__radio-container">
      <div class="radio-box">
        <input id="radio-1" type="radio" name="radio" value="viber" checked />
        <label for="radio-1">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="chack-mas"
              d="M24.625 27.8125H24.4444C3.56624 26.6119 0.601863 8.99563 0.187488 3.61938C0.154099 3.20137 0.20352 2.78088 0.332918 2.382C0.462316 1.98312 0.669148 1.6137 0.941563 1.29489C1.21398 0.976088 1.54662 0.714168 1.92044 0.524142C2.29425 0.334115 2.70189 0.219717 3.11999 0.187501H8.97436C9.39996 0.187089 9.81587 0.31448 10.1682 0.553173C10.5206 0.791866 10.7931 1.13086 10.9506 1.52625L12.5656 5.5C12.7211 5.88627 12.7597 6.30971 12.6766 6.71772C12.5935 7.12574 12.3923 7.50034 12.0981 7.795L9.83499 10.0794C10.1885 12.0883 11.1506 13.9401 12.591 15.3844C14.0314 16.8286 15.8808 17.7956 17.8887 18.1544L20.1944 15.87C20.4935 15.579 20.8716 15.3826 21.2816 15.3051C21.6916 15.2276 22.1154 15.2726 22.5 15.4344L26.5056 17.0388C26.895 17.2012 27.2273 17.4759 27.46 17.8278C27.6928 18.1798 27.8155 18.5931 27.8125 19.015V24.625C27.8125 25.4704 27.4767 26.2811 26.8789 26.8789C26.2811 27.4767 25.4704 27.8125 24.625 27.8125ZM3.37499 2.3125C3.0932 2.3125 2.82294 2.42444 2.62369 2.6237C2.42443 2.82296 2.31249 3.09321 2.31249 3.375V3.46C2.80124 9.75 5.93561 24.625 24.5612 25.6875C24.7008 25.6961 24.8407 25.6771 24.973 25.6315C25.1052 25.586 25.2271 25.5148 25.3317 25.422C25.4364 25.3292 25.5217 25.2167 25.5827 25.0908C25.6438 24.965 25.6794 24.8284 25.6875 24.6887V19.015L21.6819 17.4106L18.6325 20.4387L18.1225 20.375C8.87874 19.2169 7.62499 9.97313 7.62499 9.8775L7.56124 9.3675L10.5787 6.31813L8.98499 2.3125H3.37499Z"
            />
          </svg>
        </label>
      </div>
      <div class="radio-box">
        <input id="radio-2" type="radio" name="radio" value="telegram" />
        <label for="radio-2">
          <svg
            width="30"
            height="24"
            viewBox="0 0 30 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="chack-mas"
              d="M27.2754 0.265739L2.15789 9.95149C0.443721 10.64 0.453638 11.5962 1.84339 12.0227L8.29205 14.0343L23.2124 4.62057C23.9179 4.19132 24.5625 4.42224 24.0326 4.89257L11.9442 15.8023H11.9414L11.9442 15.8037L11.4994 22.4507C12.1511 22.4507 12.4386 22.1518 12.8041 21.7991L15.9364 18.7532L22.4516 23.5657C23.653 24.2272 24.5157 23.8872 24.8146 22.4536L29.0916 2.29724C29.5293 0.541989 28.4215 -0.252761 27.2754 0.265739Z"
            />
          </svg>
        </label>
      </div>
      <div class="radio-box">
        <input id="radio-3" type="radio" name="radio" value="whatsapp" />
        <label for="radio-3">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="chack-mas"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.1381 4.91896C23.8213 3.59353 22.2546 2.54256 20.5288 1.82695C18.8029 1.11133 16.9522 0.745297 15.0839 0.750046C7.24958 0.750046 0.871917 7.12613 0.86875 14.9636C0.86875 17.4685 1.52267 19.9131 2.76558 22.0696L0.75 29.4337L8.28508 27.4561C10.3694 28.5907 12.7045 29.1857 15.0776 29.1867H15.0839C22.9167 29.1867 29.2943 22.8106 29.2975 14.9731C29.3029 13.1056 28.9381 11.2554 28.2241 9.52972C27.5102 7.804 26.4613 6.23688 25.1381 4.91896ZM15.0839 26.788H15.0792C12.9631 26.7882 10.8859 26.2188 9.06567 25.1397L8.635 24.8832L4.16367 26.0565L5.35592 21.6975L5.07567 21.251C3.89258 19.3675 3.26629 17.1879 3.26908 14.9636C3.27225 8.44979 8.57167 3.15038 15.0887 3.15038C16.6407 3.14693 18.1781 3.45134 19.6117 4.04599C21.0453 4.64064 22.3468 5.51373 23.4408 6.61471C24.5406 7.71044 25.4123 9.01329 26.0056 10.448C26.5988 11.8826 26.9019 13.4206 26.8972 14.9731C26.894 21.487 21.5946 26.788 15.0839 26.788ZM21.5645 17.9387C21.2083 17.7598 19.4634 16.9016 19.1373 16.7829C18.8127 16.6641 18.5768 16.6055 18.3393 16.9602C18.1018 17.3149 17.4209 18.1145 17.2135 18.352C17.0061 18.5895 16.7987 18.618 16.444 18.4406C16.0893 18.2633 14.9446 17.888 13.5877 16.6784C12.5316 15.7363 11.8191 14.5741 11.6117 14.2179C11.4043 13.8616 11.5895 13.67 11.7684 13.4927C11.9283 13.3344 12.1231 13.0779 12.3004 12.8705C12.4778 12.663 12.5363 12.5158 12.6551 12.2783C12.7738 12.0408 12.7153 11.8334 12.625 11.656C12.5363 11.4771 11.8254 9.72913 11.5293 9.01821C11.2428 8.32946 10.9498 8.42129 10.7313 8.41179C10.505 8.40254 10.2786 8.39831 10.0521 8.39913C9.87199 8.40372 9.69478 8.44547 9.53158 8.52175C9.36838 8.59804 9.22269 8.70723 9.10367 8.84246C8.7775 9.19871 7.86075 10.0569 7.86075 11.8049C7.86075 13.5529 9.13375 15.2423 9.31108 15.4798C9.48842 15.7173 11.8159 19.3035 15.3784 20.8425C16.2271 21.2083 16.8889 21.4268 17.4035 21.5915C18.2538 21.8622 19.028 21.8226 19.6408 21.7324C20.3232 21.631 21.7418 20.8742 22.0379 20.0445C22.334 19.2149 22.334 18.504 22.2453 18.3551C22.1567 18.2063 21.9176 18.116 21.5645 17.9387Z"
            />
          </svg>
        </label>
      </div>
    </div>
    <div class="form__footer">
      <button id="form-home-send" class="button form__footer-button" type="submit">
        Записаться на консультацию
        <div v-show="isDisabled" class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
      <label class="policy">
          <input v-model="policy" class="policy__input" type="checkbox">
          <span class="policy__ok"></span>
          <span class="policy__text">Я согласен(на) с <a href="/politic" target="_blank">политикой конфиденциальности</a></span>
          <span class="invalid-feedback invalid-feedback--policy" v-if="!$v.policy.agree && $v.$dirty">Дайте согласие.</span>
      </label>
    </div>
  </form>
</template>

<script>
import Inputmask from "inputmask";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "FormHome",
  data: () => ({
    name: "",
    phone: "",
    policy: true,
    polit: true,
    politDirty: false,
    isDisabled: false,
    counters: null,
  }),
  methods: {
    clearData() {
      this.name = "";
      this.phone = "";
      this.politDirty = false;
    },
    addOrder() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.isDisabled = true;
      axios
        .post("/api/order", {
          name: this.name,
          phone: this.phone.replace(/\D/g, ""),
          checkbox: true,
          host: window.location.host,
          referrer: document.referrer,
          url_query_string: sessionStorage.getItem('urlQueryString'),
        })
        .then((response) => {
          this.clearData();
          this.$v.$reset();
          this.isDisabled = false;
          if (response.status === 200) {
            $("#staticBackdrop").modal("hide");
            //console.log(response.data)
            if (this.counters.ym) ym(this.counters.ym, "reachGoal", "order");
            if (this.counters.fbq) fbq("track", "Contact");
            if (this.counters.mailTarget) {
              var _tmr = window._tmr || (window._tmr = []);
              _tmr.push({
                type: "reachGoal",
                id: ` "${this.counters.mailTarget.id}" `,
                goal: ` "${this.counters.mailTarget.goal}" `,
              });
            }
            setTimeout(() => this.$store.dispatch("viewOrHideThanks"), 500);
          }
        })
        .catch((error) => {
          this.isDisabled = false;
          console.log(error.message);
        });
    },
  },
  validations: {
    name: { required, minLength: minLength(3) },
    phone: {
      required,
      isPhone: (phone) => {
        const phoneRe = /^(8|7)[\d]{10}$/;
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          return phoneRe.test(digits);
        }
        return false;
      },
    },
    policy: {
        agree: (value) => {
            return value
        }
    }
  },
  created() {
    axios
      .get("/api/counters")
      .then((response) => {
        this.counters = response.data;
      })
      .catch((error) => {
        console.log(error.message);
      });
  },
  mounted() {
    Inputmask({ mask: "+7 (999) - 999 - 99 - 99" }).mask("#form-home-phone");
  },
};
</script>

<style scoped>
.is-invalid {
  border: 1px solid tomato;
  color: tomato;
}
button[type="submit"]:disabled {
  color: #fff;
  margin: 0 auto;
}
.form__footer-button {
  display: block;
  margin: auto;
}


.invalid-feedback {
  position: absolute;
  top: -1.5rem;
  left: 0;
  width: 100%;
  color: red;
}


.invalid-feedback--policy {
    font-size: 12px;
    line-height: 14px;
    width: 100px;
    text-align: center;
    top: auto;
    bottom: -15px;
}

.policy {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    /* width: 100%; */
    max-width: 410px;
    margin: 10px auto 15px;
    position: relative;
}

.policy__input {
    display: none;
}

.policy__ok {
    display: block;
    min-width: 20px;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    background-color: #fff;
    border: 1px solid #000;
}

.policy__ok:after {
    content: "";
    width: 30px;
    height: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url('../../img/ok.svg') no-repeat center/contain;
    display: none;
}


.policy__input:checked+.policy__ok:after {
    display: block;
}

.policy__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: left;
}

.policy__text a {
    font-size: 14px;
    color: #111419;
    text-decoration: underline;
}
</style>
